<template>
  <div class="reg-self-container">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="main-form">
        <h3>Participant Information</h3>
        <div class="form-element">
          <label for="participantFirstName">First Name*</label>
          <input type="text" name="participantFirstName" v-model="participantFirstName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantFirstName') }">
          <span v-show="errors.has('participantFirstName')" class="text-danger">{{ errors.first('participantFirstName') }}</span>
        </div>
        <div class="form-element">
          <label for="participantLastName">Last Name*</label>
          <input type="text" name="participantLastName" v-model="participantLastName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantLastName') }">
          <span v-show="errors.has('participantLastName')" class="text-danger">{{ errors.first('participantLastName') }}</span>
        </div>
        <div class="form-element">
          <label for="participantEmail">Email Address*</label>
          <input type="email" name="participantEmail" v-model="participantEmail" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantEmail') }">
          <span v-show="errors.has('participantEmail')" class="text-danger">{{ errors.first('participantEmail') }}</span>
        </div>
        <div class="form-element">
          <label for="participantPhone">Phone Number</label>
          <input type="text" name="participantPhone" v-model="participantPhone" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('participantPhone') }">
          <span v-show="errors.has('participantPhone')" class="text-danger">{{ errors.first('participantPhone') }}</span>
        </div>
        <div class="form-element">
          <p>Do you have a current/updated teacher guide?*</p>
          <label for="yes">Yes</label>
          <input type="radio" id="yes" value="Yes" v-model="hasGuide">
          <label for="no" style="margin-left: 15px;">No</label>
          <input type="radio" id="no" value="No" v-model="hasGuide">
        </div>
      </div>
      <div class="main-form">
        <h3>Billing Information</h3>
        <div class="form-element">
          <label for="district">School District*</label>
          <input type="text" name="district" v-model="district" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('district') }">
          <span v-show="errors.has('district')" class="text-danger">{{ errors.first('district') }}</span>
        </div>
        <div class="form-element">
          <label for="building">Building Name*</label>
          <input type="text" name="building" v-model="building" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('building') }">
          <span v-show="errors.has('building')" class="text-danger">{{ errors.first('building') }}</span>
        </div>
        <div class="form-element">
          <label for="purchaseOrder">Purchase Order Number (Optional)</label>
          <input type="text" id="purchaseOrder" v-model="purchaseOrder">
        </div>
        <div class="form-element">
          <label for="building">Billing Address*</label>
          <input type="text" name="billingAddress" v-model="billingAddress" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingAddress') }">
          <span v-show="errors.has('billingAddress')" class="text-danger">{{ errors.first('billingAddress') }}</span>
        </div>
        <div class="form-element">
          <label for="building">Billing City*</label>
          <input type="text" name="billingCity" v-model="billingCity" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingCity') }">
          <span v-show="errors.has('billingCity')" class="text-danger">{{ errors.first('billingCity') }}</span>
        </div>
        <div class="form-element">
          <label for="building">Billing State*</label>
          <input type="text" name="billingState" v-model="billingState" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingState') }">
          <span v-show="errors.has('billingState')" class="text-danger">{{ errors.first('billingState') }}</span>
        </div>
        <div class="form-element">
          <label for="building">Billing Zip*</label>
          <input type="text" name="billingZip" v-model="billingZip" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('billingZip') }">
          <span v-show="errors.has('billingZip')" class="text-danger">{{ errors.first('billingZip') }}</span>
        </div>
        <div class="form-element">
          <label for="principalName">Principal's Name*</label>
          <input type="text" name="principalName" v-model="principalName" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('principalName') }">
          <span v-show="errors.has('principalName')" class="text-danger">{{ errors.first('principalName') }}</span>
        </div>
        <div class="form-element">
          <label for="principalEmail">Principal's Email Address*</label>
          <input type="email" name="principalEmail" v-model="principalEmail" v-validate="'required'" :class="{ 'input': true, 'border border-danger': errors.has('principalEmail') }">
          <span v-show="errors.has('principalEmail')" class="text-danger">{{ errors.first('principalEmail') }}</span>
        </div>
        <div class="form-element">
          <input type="checkbox" id="acknowledgement" v-model="acknowledge" value="false">
          <label for="acknowledgement">I acknowledge that by submitting this registration, and in order to participate in training, I have received permission from my principal, and that Cereal City Science is authorized to invoice my school/district for the cost of the training. I understand that in the event that my school/district does not cover the cost of the training, I will be responsible for full payment of the training.*<br />
            <b>Cancellation Policy</b> - Cancellations must be made at least 7 days prior to the start of the training/workshop.
          </label>
        </div>
        <div class="buttons-container">
          <button class="button" type="submit" :disabled="!acknowledge">Submit Registration</button>
          <!-- <button class="button" @click.prevent="submitRegistrationTest">Submit Registration</button> -->
          <button class="button secondary" @click.prevent="cancelRegistration">Cancel Registration</button>
        </div>
        <p>* Required fields.</p>
          <!-- <p><br />** Invoices will be sent out after the first session for Teacher Cohort Trainings.</p> -->
      </div>
    </form>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'
const dictionary = {
  en: {
    attributes: {
      district: 'District',
      building: 'Building',
      participantFirstName: 'Participant First Name',
      participantLastName: 'Participant Last Name',
      participantEmail: 'Participant Email',
      participantPhone: 'Participant Phone',
      billingAddress: 'Billing Address',
      billingCity: 'Billing City',
      billingState: 'Billing State',
      billingZip: 'Billing Zip',
      principalEmail: 'Principal Email',
      principalName: 'Principal Name'
    }
  }
}
Validator.localize(dictionary)
// import moment from 'moment'
export default {
  data() {
    return {
      district: '',
      building: '',
      purchaseOrder: '',
      acknowledge: false,
      participantFirstName: '',
      participantLastName: '',
      participantEmail: '',
      participantPhone: '',
      hasGuide: false,
      registeredBy: 'self',
      registrantFirstName: '',
      registrantLastName: '',
      registrantEmail: '',
      registrantPhone: '',
      billingAddress: '',
      billingCity: '',
      billingState: '',
      billingZip: '',
      principalName: '',
      principalEmail: ''
    }
  },
  computed: {
    ...mapState([ 'currentUser', 'userProfile', 'trainingsToRegister' ])
  },
  methods: {
    cancelRegistration() {
      this.$store.commit('SET_TRAININGS_TO_REGISTER', [])
      this.$router.push('/training')
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitRegistration()
          console.log('Result: ', result)
        } else {
          alert('Please correct errors...')
        }
      })
    },
    // submitRegistrationTest() {
    //   this.trainingsToRegister.forEach((item) => {
    //     console.log(
    //       item.selectedId,
    //       item.selectedProgram,
    //       item.selectedTitle,
    //       item.selectedSessionOne,
    //       item.selectedSessionTwo,
    //       item.selectedSessionThree,
    //       item.selectedTime,
    //       item.selectedLocation,
    //       this.userProfile.userId,
    //       this.participantFirstName,
    //       this.participantLastName,
    //       this.participantEmail,
    //       this.participantPhone,
    //       this.hasGuide,
    //       this.registeredBy,
    //       this.registrantFirstName,
    //       this.registrantLastName,
    //       this.registrantEmail,
    //       this.registrantPhone,
    //       this.district,
    //       this.building,
    //       this.billingAddress,
    //       this.billingCity,
    //       this.billingState,
    //       this.billingZip,
    //       this.purchaseOrder,
    //       this.acknowledge,
    //       new Date()
    //     )
    //   })
    // },
    submitRegistration() {
      this.trainingsToRegister.forEach((item) => {
        var sessionTwoCorrected;
        var sessionThreeCorrected;
        if (item.selectedSessionTwo === 'Invalid date') {
          sessionTwoCorrected = 'N/A',
          sessionThreeCorrected = 'N/A'
        } else {
          sessionTwoCorrected = item.selectedSessionTwo,
          sessionThreeCorrected = item.selectedSessionThree
        }
        fb.trainingRegistrationsCollection.add({
          trainingId: item.selectedId,
          program: item.selectedProgram,
          title: item.selectedTitle,
          sessionOne: item.selectedSessionOne,
          sessionTwo: sessionTwoCorrected,
          sessionThree: sessionThreeCorrected,
          time: item.selectedTime,
          location: item.selectedLocation,
          participantFirstName: this.participantFirstName,
          participantLastName: this.participantLastName,
          participantEmail: this.participantEmail,
          participantPhone: this.participantPhone,
          hasGuide: this.hasGuide,
          registeredBy: this.registeredBy,
          registrantFirstName: this.registrantFirstName,
          registrantLastName: this.registrantLastName,
          registrantEmail: this.participantEmail,
          registrantPhone: this.registrantPhone,
          district: this.district,
          building: this.building,
          billingAddress: this.billingAddress,
          billingCity: this.billingCity,
          billingState: this.billingState,
          billingZip: this.billingZip,
          principalEmail: this.principalEmail,
          principalName: this.principalName,
          purchaseOrder: this.purchaseOrder,
          acknowledge: this.acknowledge,
          sortDate: item.selectedSortDate,
          unit: item.selectedUnit,
          active: true,
          dateSubmitted: new Date()
        }).then((docRef) => {
          console.log('Registration submitted', docRef.id)
        }).then(() => {

          // this.$router.push('/training')
        }).catch((err) => {
          console.log(err)
        })
      })
      this.$store.commit('SET_TRAININGS_TO_REGISTER', [])
      this.$store.commit('SET_MSG', true)
      this.$router.push('/training')
    }
  }
  // mounted() {
  //   this.participantFirstName = this.userProfile.userFirstName
  //   this.participantLastName = this.userProfile.userLastName
  //   this.district = this.userProfile.districtName
  //   this.participantEmail = this.userProfile.userEmail
  // }
}
</script>

<style lang="css" scoped>
.registrant-container {
  border: 2px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 30px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
}
.registrant-container p {
  margin-top: 0;
  text-align: center;
}
.main-form {
  border: 2px solid #cecece;
  background: #f7f7f7;
  width: 60%;
  margin: 20px;
  padding: 20px;
  border-radius: 5px;
  margin-left: auto;
  margin-right: auto;
  vertical-align: top;
}
.form-element {
  text-align: left;
  margin-bottom: 20px;
}
input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cecece;
  border-radius: 5px;
}
input[type="radio"], input[type="checkbox"] {
  width: auto;
}
button:disabled {
  background-color: #888;
  cursor: not-allowed;
}
input[type='checkbox']{
  width: 20px;
  height: 20px;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
  transform: translateY(.1em);
}
input[type='radio']{
  width: 20px;
  height: 20px;
  margin: 5px;
  box-shadow: none;
  font-size: 2em;
  transform: translateY(.1em);
}
.text-danger {
  color: red;
  font-size: .75em;
}
.border-danger {
  border: 1px solid red;
}
</style>
